import { useState } from 'react';
import { useAction } from '../../../api/hooks';
import { Field, Textarea } from '../../../ui/forms';
import { ConfirmDialog } from '../../../ui/Modal';

export function ReasonDialog({
  title,
  description,
  confirm,
  onClose,
  run,
  invalidate,
  danger,
}: {
  title: string;
  description: string;
  confirm: string;
  onClose: () => void;
  run: (reason: string) => Promise<unknown>;
  invalidate: unknown[][];
  danger?: boolean;
}) {
  const [reason, setReason] = useState('');
  const m = useAction(() => run(reason), {
    success: 'Saved',
    invalidate: invalidate as never,
    onSuccess: onClose,
  });
  return (
    <ConfirmDialog
      title={title}
      confirmLabel={confirm}
      variant={danger ? 'danger' : 'primary'}
      onClose={onClose}
      onConfirm={() => m.mutate(undefined)}
      pending={m.isPending}
      error={m.error}
      disabled={!reason.trim()}
    >
      <p className="muted">{description}</p>
      <Field label="Reason">
        {(p) => (
          <Textarea
            {...p}
            rows={3}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            data-autofocus
          />
        )}
      </Field>
    </ConfirmDialog>
  );
}

export function DeleteOwn({
  onClose,
  run,
  inv,
}: {
  onClose: () => void;
  run: () => Promise<unknown>;
  inv: unknown[][];
  me: string;
}) {
  const m = useAction(run, { success: 'Comment removed', invalidate: inv as never, onSuccess: onClose });
  return (
    <ConfirmDialog
      title="Delete your comment?"
      confirmLabel="Yes, delete"
      variant="danger"
      onClose={onClose}
      onConfirm={() => m.mutate(undefined)}
      pending={m.isPending}
      error={m.error}
    >
      <p>A tombstone remains in the discussion.</p>
    </ConfirmDialog>
  );
}
